import {
  GET_ENGAGEMENT_FAILURE,
  GET_ENGAGEMENT_REQUEST,
  GET_ENGAGEMENT_SUCCESS,
  UPDATE_ENGAGEMENT_DATA,
} from '../action/types'

const initialState = {
  loading: true,
  data: [],
  error: '',
}

export const getEngagementMpData = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENGAGEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case GET_ENGAGEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: '',
      }
    case UPDATE_ENGAGEMENT_DATA:
      return {
        ...state,
        data: state.data.concat(action.payload),
        loading: false,
        error: '',
      }
    case GET_ENGAGEMENT_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
